import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import ko from "./locales/ko";
import { isBrowser } from "@base/lib/utils";

const STORAGE_KEY = "82office-i18nextLng";

// Safely get saved language from localStorage
const getSavedLanguage = (): string => {
  if (isBrowser && window.localStorage) {
    return localStorage.getItem(STORAGE_KEY) || "ko";
  }
  return "ko";
};

i18n.use(initReactI18next).init({
  resources: {
    en,
    ko,
  },
  lng: getSavedLanguage(),
  fallbackLng: "ko",
  debug: import.meta.env.DEV,
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  if (isBrowser && window.localStorage) {
    localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
